export class ThemeHelper {
    public theme_title: string = '';
    public theme_slogan: string = '';
    public theme_logo: string = '';
    public theme_logo_dark: string = '';
    public theme_favicon: string = '';
    public theme_accent_color: string = '';
    public theme_dark_accent_color: string = '';
    public theme_available: boolean = true;
    public theme_motd_visible: boolean = false;
    public theme_motd_text: string = '';
    public theme_motd_color: string = '';
    public theme_staging: boolean = false;
    public theme_dark_mode: boolean = false;
}
